<template>
  <div>
    <div class="targeta">
      <div class="targetaFir">
        <span class="seatar">Industry public opinion volume</span>

        <el-popover v-model="bool.showPopover" placement="bottom-end" popper-class="popoverStyle" trigger="click"
                    width="450">
          <div class="popoverLine"></div>
          <div class="popoverSelectGroup">
            <span>Nation</span>
            <el-select v-model="param.mediaCountries" class="popoverSelect" filterable multiple
                       placeholder="please select" size="mini">
              <el-option v-for="item in $parent.$parent.paramForm.countries" :key="item" :label="item" :value="item"/>
            </el-select>
          </div>
          <div class="popoverSelectGroup">
            <span>Time</span>
            <el-date-picker v-model="param.pubTime" :default-time="['00:00:00', '23:59:59']"
                            :picker-options="$parent.$parent.pickerOptions" class="popoverSelect"
                            end-placeholder="end date"
                            range-separator="——" size="mini" start-placeholder="start date" type="daterange"/>
          </div>
          <div class="popoverSelectGroup popoverSelectGroupVolume">
            <span>Volume interval</span>
          </div>
          <el-slider v-model="param.volumeInterval" :marks="options.volumeInterval" :max="600" :min="100"
                     class="sliderStyle"/>
          <div style="text-align: right; margin-top: 40px">
            <el-button icon="el-icon-close" size="mini" type="info" @click="bool.showPopover = false"/>
            <el-button icon="el-icon-check" size="mini" type="primary" @click="getIndustryVolume(true)"/>
          </div>
          <div slot="reference" class="btnsearch">
            <img alt="" src="@/views/brand/assets/img/search.png"/>
          </div>
        </el-popover>
      </div>
      <span class="seatar1">TOP10 in industry public opinion volume（from April 2023 to April 2024）</span>
    </div>
    <div class="targetaTable">
      <el-table v-loading="bool.tableLoading" :cell-style="cellStyle" :data="data.tableData" align="center"
                @cell-click="toList"
                header-cell-class-name="tableHeader" size="mini" stripe style="width: 100%">
        <el-table-column align="center" label="Ranking" min-width="20%" show-overflow-tooltip>
          <template v-slot="scope">
            <i v-if="scope.$index == 0" class="el-icon-star-on"></i>
            <span v-else :class="{ tdFir: scope.$index == 0 }">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Industry" min-width="60%" prop="label"
                         show-overflow-tooltip/>
        <el-table-column align="center" label="Heat value" min-width="20%" show-overflow-tooltip>
          <template v-slot="scope">
            <img v-if="scope.$index === 0" alt="" class="heatvalueImg" src="@/views/brand/assets/img/fire.png"/>
            <span :class="{ heatvalueFir:scope.$index === 0 }">{{ scope.row.value }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import request from '@/views/brand/utils/request'

export default {
  data() {
    return {
      bool: {showPopover: false, tableLoading: false},
      param: {mediaCountries: [], pubTime: [], volumeInterval: 300},
      data: {tableData: []},
      options: {
        volumeInterval: {100: '100', 200: '200', 300: '300', 400: '400', 500: '500', 600: '600'}
      }
    }
  },
  watch: {
    'bool.showPopover'() {
      if (this.bool.showPopover && this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        setTimeout(() => {
          this.bool.showPopover = false
        }, 1)
      }
    }
  },
  methods: {
    initVolumeLeft() {
      const date = []
      date[0] = new Date(2023, 3, 1,0,0,0);
      date[1] = new Date(2024, 3, 30, 23, 59, 59);
      this.param.pubTime = date
      this.getIndustryVolume(false)
    },
    addDataLeft() {
      this.bool.showPopover = false
    },
    // 表格的样式
    cellStyle(data) {
      if (data.columnIndex === 0 || data.columnIndex === 1) {
        if (data.columnIndex === 1 && data.rowIndex === 0) {
          return "  color: #d9001b;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', 微软雅黑;"
        }
        return "  color: #7F7F7F;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', 微软雅黑;"
      }
      if (data.columnIndex === 2) {
        return "  color: #549FEE;font-weight: 700;font-family: '微软雅黑 Bold', '微软雅黑 Regular', 微软雅黑;"
      }
    },
    getIndustryVolume() {
      this.bool.showPopover = false
      const data = JSON.parse(JSON.stringify(this.param))
      const params = {volumeInterval: this.param.volumeInterval}
      this.bool.tableLoading = true
      request({params, data, method: 'post', url: '/api/client/chinaEnterprise/industryVolume'}).then(result => {
        this.bool.tableLoading = false
        if (result && result.data && result.data.length > 10) {
          this.data.tableData = result.data.splice(0, 10)
        } else {
          this.data.tableData = result.data
        }
      }).catch(result => {
        this.bool.tableLoading = false
      })
    },
    toList(row) {
      if (this.$parent.$parent.permission.indexOf('all') === -1) {
        // this.$message.warning("You don't have permission")
        var msg = "You have no permission. If you want to have access to this section, please contact us.";
        msg = msg + "<br><br> Tel: 86-10-63076014";
        msg = msg + "<br><br> Email: silkroadweekly@xinhua.org";
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: 'warning'
        });
        return
      }
      if(row && row.label){
        this.$router.push({path: '/search', query: {showTab: '2', industry: row.label}});
      }
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.targeta {
  display: flex;
  align-items: flex-start;
  padding: 0 15px;
  flex-direction: column;
}

.targetaFir {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.seatar {
  font-weight: 700;
  font-size: 18px;
  color: #389afe;
}

.seatar1 {
  font-size: 13px;
  color: #ccc;
  margin-top: 10px;
}

.btnsearch {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.btnsearch img {
  width: 25px;
  height: 25px;
}

.popoverSelectGroup {
  display: flex;
  align-items: center;
  margin: 0 20px;
  font-size: 11px;
  margin-top: 20px;
}

.popoverSelect {
  width: 230px !important;
  margin-left: auto;
  border-radius: 15px;
  border: 1px solid #409eff;
}

.popoverSelectGroupVolume {
  margin-top: 30px;
}

.popoverSelect ::v-deep .el-input__inner {
  border-radius: 15px;
  border: none;
}

.popoverLine {
  width: 100%;
  height: 4px;
  background: #409eff;
  position: absolute;
  top: 0;
  left: 0;
}

.sliderStyle {
  width: 90%;
  margin: 20px auto 0;
  word-break: normal;
}

.targetaTable {
  padding: 0 15px 10px 15px;
  margin-top: 15px;
}

div ::v-deep .tableHeader {
  background-color: rgba(242, 242, 242, 1) !important;
  color: #333;
  font-family: "微软雅黑 Bold", "微软雅黑 Regular", 微软雅黑;
  font-weight: 700;
  padding: 2px 0;
}

div ::v-deep .el-table--striped
.el-table__body
tr.el-table__row--striped
td.el-table__cell {
  background: rgba(237, 249, 254, 1);
}

.targetaTable ::v-deep .el-table .cell.el-tooltip{
  cursor: pointer;
}

.el-icon-star-on {
  color: #d9001b;
  font-size: 25px;
}

.tdFir {
  position: absolute;
  left: 46px;
  top: 8.5px;
  color: #fff;
}

.heatvalueImg {
  height: 15px;
  width: 15px;
}

.heatvalueFir {
  color: #d9001b;
}
</style>
